import React from 'react';
import FontConfigurator from '../../../../widgets/FontConfigurator/FontConfiguratorInContext';


class TypographyRow extends React.Component {
    render() {
        const { row, value } = this.props;
        return (
            <div key={row.key} className="in-context-field-row">
                <div className="in-context-field-control">
                    <FontConfigurator
                        fontFamilyProperty={row.key}
                        fontFamilyLabel={value || "Arial, sans-serif"}
                        className="font-configurator"
                        fontFamilyClass={'font-configurator-container'}
                        value={value}
                    />
                </div>
            </div>
        );
    }
}

const TypographyGroup = ({ group, prefixKey, values }) => {
    const k = (prefixKey || 'root/typography') + '/' + group.key;
    const isOpen = true;

    return (
        <div key={group.key} className="in-context-typo-group">
            <div className="in-context-typo-group-head">
                <div className="in-context-typo-group-title">{group.title}</div>
            </div>

            <div className={'in-context-typo-group-body open'}>
                {group.rows.map(row => (
                    <TypographyRow
                        key={row.key}
                        row={row}
                        value={values[row.key]}
                    />
                ))}
            </div>
        </div>
    );
};
export const TypographyPanel = ({ item, prefix, open, values, toggle, keyFor }) => {
    const key = keyFor(prefix, item);
    const isOpen = !!open[key];

    return (
        <li key={key} className="in-context-menu-item is-selected">
            <div className="in-context-menu-label">
                <button
                    type="button"
                    className="in-context-menu-button"
                    onClick={() => toggle(key)}
                >
                    {item.name}
                </button>
                <button
                    type="button"
                    className="in-context-toggle"
                    onClick={() => toggle(key)}
                    aria-label={isOpen ? 'Collapse' : 'Expand'}
                >
                    {isOpen ?
                        <i className="spark-icon-arrow-chevron-down spark-icon--fill" /> :
                        <i className="spark-icon-arrow-chevron-up spark-icon--fill" />
                    }
                </button>
            </div>

            <div className={'in-context-submenu' + (isOpen ? ' open' : '')}>
                <div className="in-context-typography-panel">
                    {item.groups.map(group => (
                        <TypographyGroup
                            key={group.key}
                            group={group}
                            prefixKey={key}
                            open={open}
                            toggle={toggle}
                            values={values}
                        />
                    ))}
                </div>
            </div>
        </li>
    );
};


// WEBPACK FOOTER //
// ./src/components/pages/in-context/SidebarNavigation/panels/TypographyPanel.js